import React, { Fragment } from 'react';
import { CardBody } from 'reactstrap';
import {
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_getBuildingURL,
	BuildingPhoto,
	_shouldShow,
	HouseCurrentStatus,
	_getBuildingPhotos,
} from '../../../shared/helpers/utils';
import moment from 'moment';

const HouseGridView = ({ data, onBuildingClick }) => {
	return (
		<div className="catalog-items__wrap">
			<div className="catalog-items">
				{data.map((d) => (
					<CardBody
						className="catalog-item"
						key={d.id}
						onClick={(e) => onBuildingClick(e, d)}
						style={{ cursor: 'pointer' }}
					>
						<div className="catalog-item__img-wrap">
							<BuildingPhoto item={d} />
						</div>
						<div className="catalog-item__info">
							<h4 className="catalog-item__price">
								{d.name ? _capitalizeText(d.name) : _capitalizeText(d.display_full_street_address)}
								{d.name && (
									<div>{_capitalizeText(d.display_full_street_address)}</div>
								)}
								<div className="light-text small-text" style={{ color: '#858AA1' }}>
									{d.neighborhood && d.neighborhood[0] ? `${_capitalizeText(d.neighborhood[0])}, ` : ''}
									{_capitalizeText(d.borough)}
								</div>
							</h4>
							<h5 className="product-card__title">
								<span className="light-text small-text">
									{d.total_units > 1 ? 'Multi-Family (' + _formatNumber(d.total_units) + ' Units)' : 'Single-Family'}
								</span>
								{d.bedrooms > -1 && (
									<Fragment>
										<span className="small-divider">|</span>
										<span className="light-text small-text">{d.bedrooms === 0 ? 'Studio' : d.bedrooms + ' Bed'}</span>
									</Fragment>
								)}
								{d.baths > 0 && (
									<Fragment>
										<span className="small-divider">|</span>
										<span className="light-text small-text">{d.baths} Bath</span>
									</Fragment>
								)}
								{d.sq_ft > 1 && (
									<Fragment>
										<span className="small-divider">|</span>
										<span className="light-text small-text">{_formatNumber(d.sq_ft)} sf</span>
									</Fragment>
								)}
							</h5>
							<div style={{ marginTop: 4 }}>
								{d.last_listed_sale_price_all > 100 && (
									<div className="light-text small-text">
										Asking: <strong>${_formatNumber(d.last_listed_sale_price_all)}</strong>
									</div>
								)}
								{d.last_sold_price > 100 && (
									<div className="light-text small-text" style={{ marginTop: 4 }}>
										Sold: <strong>${_formatNumber(d.last_sold_price)}</strong>
										{d.last_sold_date > 0 && (
											<span style={{ color: '#858AA1' }}> ({moment.unix(d.last_sold_date).fromNow()})</span>
										)}
									</div>
								)}
							</div>
						</div>
						<HouseCurrentStatus status={d.current_status} unit={d} />
					</CardBody>
				))}
			</div>
		</div>
	);
};

export default HouseGridView;
